import route from 'ziggy-js';
import { Ziggy } from '../../../js/ziggy';

Ziggy.protocol = window.location.protocol;
Ziggy.domain = document.domain;
Ziggy.port = window.location.port;
Ziggy.url = `${Ziggy.protocol}//${Ziggy.domain}`;
if (Ziggy.port) {
  Ziggy.url = `${Ziggy.url}:${Ziggy.port}`;
}

// Ziggy（jsで使えるnamed route）はグローバルオブジェクトを参照するため、初期化しておく必要がある
window.Ziggy = Ziggy;

route.routeObject = route();
const currentRoute = route().current();
route.currentRoute = currentRoute;
route.isMatchingRoute = currentRoute.indexOf('matching') > 0;
route.isMapMatchingRoute = currentRoute.indexOf('map.matching') > 0;
route.isShareRoute = currentRoute.indexOf('share') > 0;
route.isCreateRoute = currentRoute.indexOf('create') > 0;

export default route;
